export const TRATAMIENTOS = [
  { value: "REVISION", label: "Revisión", color: "#1890ff" },
  { value: "PRIMERA_CITA", label: "1ª cita", color: "#722ed1" },
  { value: "HIGIENE", label: "Higiene", color: "#13c2c2" },
  { value: "BRAQUETS", label: "Puesta braquets", color: "#fa8c16" },
  { value: "ORTODONCIA", label: "Ortodoncia", color: "#eb2f96" },
  { value: "CIRUGIA", label: "Cirugía", color: "#f5222d" },
  { value: "EXTRACCION", label: "Extracción", color: "#a8071a" },
  { value: "BLANQUEAMIENTO", label: "Blanqueamiento", color: "#52c41a" },
  { value: "ENDODONCIA", label: "Endodoncia", color: "#2f54eb" },
  { value: "PRESUPUESTO", label: "Presupuesto", color: "#595959" }
];